import { TicketCategoryData } from 'data';
import styles from './ticketCard.module.scss';
import { TimeDifference } from 'scripts';
import { TicketStatusEnum, TicketType } from 'types';

function TicketCardComp({
    className,
    data,
    onClick,
}: {
    className?: string;
    data: TicketType;
    onClick: (e: number) => void;
}) {
    return (
        <div className={`${styles['ticket-card-layout']} p-1 ${className} pointer`} onClick={() => onClick(data.id)}>
            <div className="flex-between center-content-y">
                <p className="t-p1 t-400 t-l-black1">{data.title}</p>
                <p className="t-p3 t-400 t-l-gray1">{TimeDifference(data.created_at)}</p>
            </div>
            <div className="flex-between center-content-y g-1">
                <p className={`${styles['type']} t-p3 t-400 t-l-gray1`}>
                    {TicketCategoryData.find((i) => i.value === data.category)?.title}
                </p>
                {data.status === TicketStatusEnum.pending ? (
                    <span className="t-p3 t-l-gray2">در انتظار بررسی</span>
                ) : null}
                {data.status === TicketStatusEnum.answered ? (
                    <span className="t-p3 t-primary">پاسخ داده شده</span>
                ) : null}
                {data.status === TicketStatusEnum.closed ? <span className="t-p3 t-primary">بسته شده</span> : null}
            </div>
        </div>
    );
}

export default TicketCardComp;
